import moment from 'moment-timezone'

export const announcementTimezone = 'Australia/Melbourne'
const calendarFormatter = new Intl.DateTimeFormat('en', {
  timeZone: announcementTimezone, year: 'numeric', month: '2-digit', day: '2-digit'
})
export const recurrenceUnits = [
  { value: 'none', label: 'Does not repeat' },
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'year', label: 'Year' }
]

export const announcementStatuses = {
  pending: 'Pending', coming_soon: 'Coming soon', ongoing: 'Ongoing',
  between_cycles: 'Between cycles', expired: 'Expired'
}

export function announcementCalendarDate (value) {
  if (!value) return null
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return moment.utc(value, 'YYYY-MM-DD', true).isValid() ? value : null
  }
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  // Native timezone rules continue past the old bundled Moment data's 2037 cutoff.
  const parts = Object.fromEntries(calendarFormatter.formatToParts(date).map(({ type, value }) => [type, value]))
  return `${parts.year.padStart(4, '0')}-${parts.month}-${parts.day}`
}

export function announcementDate (value) {
  const date = announcementCalendarDate(value)
  if (!date) return '—'
  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}

export function recurrenceSummary (item) {
  if (!item.repeat_unit || item.repeat_unit === 'none') return 'Does not repeat'
  const { repeat_unit: unit, repeat_interval: interval, repeat_count: count } = item
  return `${interval} ${unit}${interval === 1 ? '' : 's'} gap · ${count} occurrence${count === 1 ? '' : 's'} total`
}

export function nextOccurrence (item) {
  if (!item.next_occurrence_start) return '—'
  const start = announcementDate(item.next_occurrence_start)
  return item.next_occurrence_end ? `${start} – ${announcementDate(item.next_occurrence_end)}` : `${start} onwards`
}
